import { useDrag } from 'react-dnd';
import './blockSourceButton.less';
import { useRef } from 'react';
import { Paragraph } from '../../typography';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import IcoDrag from 'components/icon/icons/IcoDrag';

interface EmbedBlockButtonProps {
  title: string;
  onClickAdd?: () => void;
}

const EmbedBlockButton = ({ title, onClickAdd }: EmbedBlockButtonProps) => {
  const wasDraggingRef = useRef(false);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'EMBED',
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    item: () => {
      wasDraggingRef.current = true;
      return { title };
    },
    end: () => {
      requestAnimationFrame(() => {
        wasDraggingRef.current = false;
      });
    },
  }));

  const handleClick = () => {
    if (wasDraggingRef.current) return;
    onClickAdd?.();
  };

  return (
    <button ref={drag} draggable className="block-source" style={{ opacity: isDragging ? 0.5 : 1 }} onClick={handleClick}>
      <div className="block-source-icon">
        <CodeRoundedIcon />
      </div>
      <div className="block-source-drag-icon">
        <IcoDrag />
      </div>
      <Paragraph size="sm">{title}</Paragraph>
    </button>
  );
};

export default EmbedBlockButton;
EmbedBlockButton.displayName = 'EmbedBlockButton';
